import styled from "styled-components";

export const ItemSeparator = styled.div`
  border-width: 1px;
  border-top-style: solid;
  border-color: ${(props) => props.theme.colours.lightGrey};
`;
